import { defaultTheme } from '@mnd-frontend/ui/shared/tokens';

export const iconSizeMap = {
  xxs: defaultTheme.sizingIconXxs,
  xs: defaultTheme.sizingIconXs,
  sm: defaultTheme.sizingIconSm,
  md: defaultTheme.sizingIconMd,
  lg: defaultTheme.sizingIconLg,
  xl: defaultTheme.sizingIconXl,
  '2xl': defaultTheme.sizingIcon2xl,
  '3xl': defaultTheme.sizingIcon3xl,
} as const;
